;(function () {
  angular.module('contrast.filters').filter('truncatePercent', function () {
    //Limit to integer
    return function (input) {
      if (angular.isNumber(input)) {
        input = Math.round(input)
      }
      return input
    }
  })
})()
